import { icon } from 'leaflet';

import MarkerIconBlue from '../../FloorPlanMap/assets/marker-icon-blue.png';
import MarkerIconGreen from '../../FloorPlanMap/assets/marker_green.png';
import MarkerIconGrey from '../../FloorPlanMap/assets/marker_grey.png';
import MarkerIconAmber from '../../FloorPlanMap/assets/marker_amber.png';
import MarkerIconRed from '../../FloorPlanMap/assets/marker_red.png';
import MarkerShadow from '../../FloorPlanMap/assets/marker-shadow.png';
import { MapBoundsType, MapCoordinatesType } from '../../@types';

export const getLeafletIcon = (
  color: 'amber' | 'red' | 'green' | 'grey' | 'blue' = 'blue'
) => {
  let leafletIcon = MarkerIconBlue;
  if (color === 'amber') {
    leafletIcon = MarkerIconAmber;
  } else if (color === 'red') {
    leafletIcon = MarkerIconRed;
  } else if (color === 'green') {
    leafletIcon = MarkerIconGreen;
  } else if (color === 'grey') {
    leafletIcon = MarkerIconGrey;
  }

  return icon({
    iconUrl: leafletIcon,
    shadowUrl: MarkerShadow,
    iconSize: [25, 41],
    shadowSize: [41, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
  });
};

export const getMapBoundsAndCenter = ({
  height,
  width,
}: {
  height: number;
  width: number;
}): { bounds: MapBoundsType; centre: MapCoordinatesType } => {
  let mapHeight = height;
  let mapWidth = width;

  if (mapHeight > 1000 && mapWidth > 1000) {
    mapHeight = mapHeight / 10;
    mapWidth = mapWidth / 10;
  }

  const topLeft: [number, number] = [0, 0];
  const bottomRight: [number, number] = [mapHeight, mapWidth];
  const bounds: MapBoundsType = [topLeft, bottomRight];
  const centre: MapCoordinatesType = [bottomRight[0] / 2, bottomRight[1] / 2];
  return { bounds, centre };
};
